import { CatHeading } from '@blocks-react/components/Heading';
import { EquipmentInfoHeadingProps } from '../types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { useMemo } from 'react';
import { CatTextPassage } from '@blocks-react/components/TextPassage';

export const EquipmentInfoHeading = ({
  children,
  showTooltip = true,
  ...headingProps
}: EquipmentInfoHeadingProps) => {
  const label = useMemo(() => {
    return (
      <CatHeading slot="trigger" {...headingProps}>
        <span className="text-truncate d-block color-black">{children}</span>
      </CatHeading>
    );
  }, [children, headingProps, showTooltip]);
  return showTooltip ? (
    <CatTooltip position="auto" className="text-truncate lh-1">
      {label}
      <CatTextPassage className="text-wrap">{children}</CatTextPassage>
    </CatTooltip>
  ) : (
    <> {label}</>
  );
};
